<template>
  <div class="wui-container home">
    <!-- swiper -->
    <Swiper
        type="home"
        :video="banner.video"
        :imgs="banner.imgs"
        :height="280"
    ></Swiper>

    <!-- 城市选择 -->
    <div class="select-city">
      <img class="bg" src="@/assets/img/home-bg.png"/>
      <div class="main">
        <div class="city-input" @click="setSelectCityVisible">
          <div class="city-name">{{ currentCity.name }}</div>
          <i class="iconfont icon-trigon"></i>
        </div>
        <div class="btn-search" @click="search">
          <i class="iconfont icon-Search"></i>
          <span>{{ $t("搜索房源") }}</span>
        </div>
      </div>
    </div>

    <!-- 城市弹窗 -->
    <div
        :class="`city-dialog ${language == 2 ? 'en' : ''}`"
        v-show="selectCityVisible"
    >
      <div class="mask" @click="selectCityVisible = false"></div>
      <div class="dialog-main">
        <div class="dialog-header">
          <h3>{{ $t("选择城市") }}</h3>
          <img
              @click="selectCityVisible = false"
              src="@/assets/img/icon-close.png"
              alt="img"
          />
        </div>
        <div class="city-list">
          <div
              class="city-item"
              @click="selectCity(item)"
              :class="{
                            'city-item-active': item.id == currentCity.id,
                        }"
              v-for="item in openCityList"
              :key="item.id"
          >
            <span class="name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 城市攻略 -->
    <div class="section city-guide">
      <div class="list">
        <div class="list-wrapper">
          <a
              :href="`https://www.wellcee.com/${item.spell}/m/rent-apartment`"
              class="guide-item"
              v-for="item in openCityList"
              :key="item.id"
          >
            <div class="guide-img">
              <img :src="util.thumb(item.img, 400)"/>
            </div>
            <div class="guide-info">
              <div class="city-name">{{ item.name }}</div>
              <div class="online-number">
                {{ item.info.online_text }}
              </div>
              <div class="house-total">
                {{ item.info.total_text }}
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- 标签 -->
    <van-tabs v-model:active="currentTag" shrink sticky @change="selectTag" line-width="32" color="#2db6b4"
              title-active-color="#000" title-inactive-color="#999" swipeable>
      <van-tab v-for="item in tagList" :title="item.name" :name="item.id" :key="item.id">
        <!--   社区   -->
        <div class="community-list">
          <!-- 列表 -->
          <van-list
              v-model:loading="loading"
              :finished="finished"
              :loading-text="$t('加载中')"
              @load="onLoad"
          >
            <div class="list">
              <template v-if="leftList?.length && rightList?.length">
                <div class="list-col left">
                  <CommunityItem v-for="item in leftList" :key="item.id" :info="item"></CommunityItem>
                </div>
                <div class="list-col right">
                  <CommunityItem v-for="item in rightList" :key="item.id" :info="item"></CommunityItem>
                </div>
              </template>
              <div class="empty" v-else-if="!loading">
                <van-empty
                    :image="emptyImg"
                    description="没有找到相关内容呢"/>
              </div>
            </div>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 打开APP -->
    <div class="open-app" @click="$downloadApp">
      <div class="btn-open">{{ $t("打开APP") }}</div>
    </div>
    <Transition name="fade-up">
      <div class="roll-top" :class="showRollTop && 'roll-top-show'" v-if="showRollTop" @click="scrollToTop">
        <van-icon name="arrow-up"/>
      </div>
    </Transition>
  </div>
</template>

<script>
import {useRouter} from "vue-router";
import emptyImg from "@/assets/img/empty.svg"
import api from "@/api/index";
import Swiper from "@/components/Swiper.vue";
import {initWechatJSSDK} from "@/assets/wechat.js";
import {
  List as VanList,
  Sticky as VanSticky,
  Icon as VanIcon,
  Tabs as VanTabs,
  Tab as VanTab,
  Empty as VanEmpty
} from "vant";
import CommunityItem from "@/components/CommunityItem.vue";

export default {
  components: {
    CommunityItem,
    VanList,
    VanIcon,
    VanTabs,
    VanTab,
    VanEmpty,
    Swiper,
  },
  data() {
    return {
      banner: {
        video: "",
        imgs: [],
      },
      emptyImg,
      openCityList: [],
      notOpenCityList: [],
      currentCity: {},
      currentTag: '',
      selectCityVisible: false,

      lifestyleList: [], // lifestyle推荐列表
      usedList: [], // 二手推荐列表

      discoverList: [], // 探索文章列表
      exploreList: [], // 体验文章列表

      language: this.util.language(),
      tagList: [],
      loading: false,
      finished: false,
      pn: 0,
      ps: 20,
      leftList: [],
      rightList: [],
      leftHeight: 0,
      rightHeight: 0,
      showRollTop: false
    };
  },
  setup() {
    const router = useRouter();
    return {
      router,
    };
  },
  mounted() {
    this.getConfig();
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    //滚动监听
    handleScroll() {
      this.showRollTop = window.scrollY > 300;
    },
    // 刷新
    onRefresh() {
      // window.scrollTo(0, 0);
      this.pn = 1;
      this.loading = true;
      this.finished = false;
      this.getCommunityList(true);
    },
    // 加载
    onLoad() {
      if (this.finished) {
        return false;
      }
      this.pn++;
      this.getCommunityList();
    },
    getCommunityList(flag) {
      let params = {
        page: this.pn,
        size: this.ps,
      };
      if (this.currentCity.id) {
        params.cityId = this.currentCity.id;
      }
      if (this.currentTag) {
        params.categoryId = this.currentTag;
      }
      api.community.getCommunityList(params).then(res => {
        let data = res.data?.list || [];
        let leftHeight = flag ? 0 : this.leftHeight;
        let rightHeight = flag ? 0 : this.rightHeight;
        let leftList =  flag ? [] :this.leftList;
        let rightList =  flag ? [] :this.rightList;

        data.forEach(item => {
          item.width = item?.cover?.width || 800;
          item.height = item?.cover?.height || 800;

          // if (item.height / item.width > 1) {
          //   item.rectangle = true;
          // }
          if (item.shape === 'rect') {
            item.rectangle = true;
          }
          if (rightHeight >= leftHeight) {
            leftList.push(item);
            if (item.rectangle) {
              leftHeight += 1.5;
            } else {
              leftHeight += 1;
            }
          } else {
            rightList.push(item);
            if (item.rectangle) {
              rightHeight += 1.5;
            } else {
              rightHeight += 1;
            }
          }
        });
        if (data.length < this.ps) {
          this.finished = true;
        }

        this.leftHeight = leftHeight;
        this.rightHeight = rightHeight;
        this.leftList = leftList;
        this.rightList = rightList;

        this.$nextTick(() => {
          this.loading = false;
        })
      });
    },
    // 获取社区 标签列表
    getTagList() {
      api.community.getCommunityTagList({cityId: this.currentCity.id}).then(res => {
        res.data.forEach(item => {
          item.isSelected = false;
        });
        res.data.unshift({
          id: '',
          name: this.$t('推荐'),
          isSelected: true
        });
        this.tagList = res.data;
      });
    },
    // 选择标签
    selectTag() {
      this.onRefresh();
    },
    // 选择城市弹窗
    setSelectCityVisible() {
      this.selectCityVisible = true;
    },
    // 选择城市
    selectCity(item) {
      this.currentCity = item;
      this.selectCityVisible = false;
      localStorage.setItem(
          "wellcee.home.currentCity",
          JSON.stringify(this.currentCity)
      );
      this.currentTag = '';
      this.getTagList();
      this.onRefresh();
    },
    // 搜索房源
    search() {
      this.router.push(
          `/rent-apartment/${this.currentCity.spell}/list?cityId=${this.currentCity.id}`
      );
    },
    // 首页数据 【banner、城市、城市攻略、slogan】
    getConfig() {
      api.home
          .getConfig({
            ...this.util.getUrlSearch(),
            lang: this.util.language(),
            platform: 2,
          })
          .then((res) => {
            if (res.data.banner[0].media == 2) {
              this.banner.video = res.data.banner[0].url;
            } else {
              this.banner.imgs = res.data.banner;
            }

            this.openCityList = res.data.openCity;
            this.notOpenCityList = res.data.notOpenCity;
            this.currentCity =
                JSON.parse(
                    localStorage.getItem("wellcee.home.currentCity")
                ) || res.data.openCity[0];
            this.getTagList();

            initWechatJSSDK({
              title: "Wellcee · 唯心所寓",
              desc: this.$t("让世界上每一个有可能的地方都变成家"),
              imgUrl: "https://qnimg1.wellcee.com/app.png",
            });
          });
    },
  },
};
</script>
<style lang="scss" scoped>
/* .home {
    filter: grayscale(0.95);
} */
.open-app {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 15px;
  background-color: rgba(255, 255, 255, 0.7);
  border-top: 1px solid #f8f8f8;
}

.open-app .btn-open {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  background-color: #2db6b4;
  color: #ffffff;
  font-size: 14px;
  border-radius: 4px;
}

.home {
  padding-bottom: 70px;
  overflow: hidden;
  background: #ffffff;
}

.city-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  z-index: 1000;
}

.city-dialog .mask {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(17, 17, 17, 0.6);
}

.city-dialog .dialog-main {
  position: relative;
  z-index: 1001;
  margin: 0 35px;
  background: #ffffff;
  border-radius: 10px;
  padding: 15px 10px 10px 20px;
  box-sizing: border-box;
}

.city-dialog .dialog-header {
  position: relative;
  height: 20px;
  margin-bottom: 20px;
}

.city-dialog .dialog-header h3 {
  color: #111;
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  margin: 0;
}

.city-dialog .dialog-header img {
  position: absolute;
  top: 0;
  right: 10px;
  width: 24px;
  height: 24px;
}

.city-dialog .city-list {
  display: flex;
  flex-wrap: wrap;
}

.city-dialog .city-list .city-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(25% - 10px);
  box-sizing: border-box;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 7px 0;
  font-size: 14px;
  color: #111111;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  border-radius: 10px;
  border: 1px solid rgba(17, 17, 17, 0.1);
}

.city-dialog .city-list .city-item-active {
  color: #2db6b4;
  border-radius: 10px;
  border: 1.5px solid #2db6b4;
  background: rgba(45, 182, 180, 0.05);
}

.city-dialog.en .city-list .city-item {
  width: auto;
  padding: 7px 10px;
  font-size: 13px;
}

.article .list {
  overflow-x: scroll;
  margin: 0 -15px;
  padding: 0 15px 0px 15px;
}

.article .list-wrapper {
  width: 100%;
  display: flex;
}

.article .article-item {
  float: left;
  width: 47%;
  flex-shrink: 0;
  text-align: left;
  margin-right: 8px;
}

.article .article-item .img {
  position: relative;
  width: 100%;
  border-radius: 2px;
  padding-bottom: 70%;
}

.article .article-item img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.article .article-item .title {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  height: 40px;
  color: #111111;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.article .intro {
  font-size: 12px;
  line-height: 17px;
  color: #666666;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.discover .card .top {
  display: flex;
  margin-bottom: 1px;
}

.discover .card .bottom {
  display: flex;
}

.discover .card .right {
  flex: 1;
  margin-left: 1px;
}

.discover .card .card-item {
  position: relative;
  display: block;
}

.discover .card .card-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.discover .card .card-item .title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  height: 26px;
  line-height: 26px;
  padding: 0 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.6) 100%
  );
  font-size: 12px;
  color: #ffffff;
  text-shadow: 0px 0px 20px #000000;
}

.discover .card1 {
  width: 139px;
  height: 140px;
  margin-right: 1px;
}

.discover .card1 img {
  border-radius: 4px 0 0 0;
}

.discover .card2 {
  flex: 1;
  height: 140px;
}

.discover .card2 img {
  border-radius: 0 4px 0 0;
}

.discover .card3 {
  width: 210px;
  height: 180px;
}

.discover .card3 img,
.discover .card3 .title {
  border-radius: 0 0 0 4px;
}

.discover .card4 {
  height: 90px;
  margin-bottom: 1px;
}

.discover .card5 {
  height: 89px;
}

.discover .card5 img,
.discover .card5 .title {
  border-radius: 0 0 4px 0;
}

.subject .list {
  overflow-x: scroll;
  margin: 0 -15px;
  padding: 0 15px 0px 15px;
}

.subject .list-wrapper {
  width: 100%;
  display: flex;
}

.subject .item {
  width: 47%;
  float: left;
  flex-shrink: 0;
  margin-right: 8px;
}

.subject .item .poster {
  position: relative;
  border-radius: 6px;
  padding-bottom: 135%;
  background-color: #f8f8f8;
}

.subject .item .poster .img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px 6px 0 0;
}

.subject .item .content {
  padding: 10px;
  border-radius: 0 0 6px 6px;
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.subject .item .title {
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  height: 40px;
  color: #111111;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.subject .item .other {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}

.subject .item .user {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.subject .item .user .avatar {
  display: inline-block;
  width: 19px;
  height: 19px;
  min-width: 19px;
  border-radius: 3px;
  margin-right: 6px;
}

.subject .item .user .name {
  font-size: 12px;
  color: #111111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
}

.subject .item .comment {
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #666666;
}

.subject .item .comment .iconfont {
  margin-right: 4px;
  font-size: 10px;
}

.used .item .poster {
  padding-bottom: 100%;
}

.used .item .poster .img {
  border-radius: 4px 4px 0 0;
}

.used .item .content {
  border-radius: 0 0 4px 4px;
}

.used .item .title {
  display: block;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  color: #111111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.used .item .used-price {
  display: flex;
  align-items: center;
  margin: 4px 0 12px 0;
  height: 17px;
}

.used .item .used-price .price {
  font-size: 12px;
  color: #2db6b4;
  margin-right: 4px;
}

.used .item .used-price .original {
  font-size: 12px;
  text-decoration-line: line-through;
  color: #999999;
}

.section {
  padding: 0 15px;
}

.section .section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 0 15px 0;
}

.section .section-header .title {
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #111111;
}

.section .section-header .more {
  font-size: 12px;
  color: #666666;
}

.city-guide .list {
  overflow-x: scroll;
  overflow-y: hidden;
  margin: 0 -15px;
  padding: 0 15px 0px 15px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.city-guide .list::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

.city-guide .list-wrapper {
  width: 100%;
  display: flex;
}

.city-guide .guide-item {
  position: relative;
  width: 47%;
  height: 90px;
  flex-shrink: 0;
  margin-right: 8px;
  border-radius: 4px;
}

.city-guide .guide-item .guide-img {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.city-guide .guide-item .guide-img img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: cover;
}

.city-guide .guide-item .guide-info {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  background-color: rgba(38, 37, 37, 0.4);
  border-radius: 4px;
}

.city-guide .guide-item .city-name {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  margin-bottom: 3px;
}

.city-guide .guide-item .online-number {
  font-size: 10px;
  line-height: 14px;
  color: #ffffff;
}

.city-guide .guide-item .house-total {
  font-size: 10px;
  line-height: 14px;
  color: #ffffff;
}

.select-city {
  position: relative;
  margin-top: -50px;
  display: flex;
}

.select-city .bg {
  width: 100%;
  height: 145px;
}

.select-city .main {
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
}

.select-city .city-input {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-radius: 40px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
}

.select-city .city-input .city-name {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #111111;
  margin-right: 4px;
}

.select-city .city-input .iconfont {
  color: rgba(79, 89, 100, 1);
  font-size: 7px;
}

.select-city .btn-search {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background: #2db6b4;
  box-shadow: 0px 10px 20px rgba(44, 172, 170, 0.26);
  border-radius: 36px;
  margin-top: 15px;

  font-size: 16px;
  color: #ffffff;
}

.select-city .btn-search .iconfont {
  color: #ffffff;
  margin-right: 8px;
  font-size: 20px;
}

.header {
  height: 50px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  z-index: 1000;
  max-width: 500px;
  margin: 0 auto;

  .tags {
    height: 50px;
    overflow-x: auto;
  }

  .tag-list {
    display: flex;
    height: 50px;
  }

  .tag-item {
    display: flex;
    align-items: center;
    padding: 0 7px;
    height: 26px;
    background: rgba(17, 17, 17, 0.03);
    border-radius: 6px;
    margin-right: 15px;
    margin-top: 12px;

    font-size: 14px;
    color: #111111;
    white-space: nowrap;
  }

  .tag-active {
    color: rgba(45, 182, 180, 1);
    background: rgba(45, 182, 180, 0.05);
  }
}


.community-list {
  .list {
    display: flex;
    align-items: flex-start;
    padding: 0px 15px 20px 15px;
    background: #fbfbfb;

    .empty {
      width: 100%;


    }
  }

  .list .list-col {
    width: 50%;
    overflow: hidden;
  }

  .list .left {
    margin-right: 13px;
  }
}

.roll-top {
  position: fixed;
  bottom: 84px;
  right: 16px;
  width: 40px;
  height: 40px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2DB6B4;
  border-radius: 50%;
  box-shadow: 0 10px 20px rgba(44, 172, 170, 0.26);
  opacity: 0;
  pointer-events: none;
  transform: translateY(10px);
  z-index: 1000;

  &-show {
    opacity: 1;
    pointer-events: auto; // 显示时启用点击
  }

  &:active {
    transform: scale(0.95); // 点击时轻微缩小
    transition: transform 0.1s ease;
  }
}

.fade-up-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

/* 离开动画的结束状态 */
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* 进入和离开的活动状态 */
.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 0.3s ease, transform 0.4s ease;
}

:deep(.van-tabs) {
  margin-top: 8px;
  background: #FFFFFF;

  .van-tab {
    font-size: 16px;
    margin-right: 9px;
  }

  .van-tabs__wrap {
    padding: 0 7px 4px;
  }

  .van-tabs__line {
    bottom: 20px;
    background: #2DB6B4;
  }
}
:deep(.van-empty) {
  .van-empty__image{
    width: 94px;
    height: 80px;
  }
}
</style>
